import { api } from "../../api";

export const dashboardBuilderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardTemplates: builder.query({
      query: () => ({
        url: "/dashboards/templates",
      }),
      transformResponse: (response) => response.data || [],
      providesTags: ["DynamicDashboard"],
    }),
    getDashboards: builder.query({
      query: () => ({
        url: "/dashboards",
      }),
      transformResponse: (response) => response.data || [],
      providesTags: ["DynamicDashboard"],
    }),
    getDefaultDashboardDefinition: builder.query({
      query: () => ({
        url: "/dashboards/default",
      }),
      transformResponse: (response) => response.data,
      providesTags: ["DynamicDashboard"],
    }),
    getDashboardDefinition: builder.query({
      query: (id) => ({
        url: `/dashboards/${id}`,
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, id) => [
        { type: "DynamicDashboard", id },
      ],
    }),
    resolveDashboard: builder.mutation({
      query: ({ id, filters = {} }) => ({
        url: `/dashboards/${id}/resolve`,
        method: "POST",
        body: { filters },
      }),
      transformResponse: (response) => response.data,
    }),
    createDashboardFromTemplate: builder.mutation({
      query: (body) => ({
        url: "/dashboards/from-template",
        method: "POST",
        body,
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ["DynamicDashboard"],
    }),
    updateDashboard: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/dashboards/${id}`,
        method: "PUT",
        body,
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: (result, error, { id }) => [
        "DynamicDashboard",
        { type: "DynamicDashboard", id },
      ],
    }),
    deleteDashboard: builder.mutation({
      query: (id) => ({
        url: `/dashboards/${id}`,
        method: "DELETE",
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ["DynamicDashboard"],
    }),
    setDefaultDashboard: builder.mutation({
      query: (id) => ({
        url: `/dashboards/${id}/default`,
        method: "PATCH",
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ["DynamicDashboard"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateDashboardFromTemplateMutation,
  useDeleteDashboardMutation,
  useGetDashboardTemplatesQuery,
  useGetDashboardsQuery,
  useGetDefaultDashboardDefinitionQuery,
  useGetDashboardDefinitionQuery,
  useResolveDashboardMutation,
  useSetDefaultDashboardMutation,
  useUpdateDashboardMutation,
} = dashboardBuilderApi;
